<template>
  <div v-cloak>
    <router-view/>

    <!-- disabled facebook chat since there's no automation there-->
    <!--<facebook-chat></facebook-chat>-->

    <cookies-consent></cookies-consent>
  </div>
</template>

<script>
  import CookiesConsent from '@/components/common/CookiesConsent'
  import $script from 'scriptjs'
  // import FacebookChat from '@/components/common/FacebookChat'

  export default {
    name: 'App',
    metaInfo: {
      titleTemplate: '%s | Amio',
      title: 'AI-Driven Customer Support Automation',
      meta: [
        {
          description: 'Amio is an easy-to-install virtual customer assistant. It improves on the go and ensures a high return on investment (ROI).'
        }
      ]
    },
    components: {
      CookiesConsent
      // FacebookChat
    },
    mounted() {
      new Promise(resolve => {
        $script('https://chat-widget.amio.io/static/amio-webchat-loader.min.js', resolve)
      }).then(() => {
        window.amioWebchat.init({
          channelId: '6950798231283188364',
          logoUrl: 'https://amio-testing.s3.eu-central-1.amazonaws.com/amio_logo.png',
          startOpened: false,
          theme: 'amio',
          zIndex: '2000'
        })
      })
    }
  }
</script>

<style lang="scss">
  // Roboto fontface is different in npm
  @import url(https://fonts.googleapis.com/css?family=Roboto+Mono:400,500&amp;subset=latin-ext);
  @import 'assets/css/main.css';
  @import 'assets/css/hp_new.css';
  @import 'assets/css/ie-only.css';

  [v-cloak] {
    display: none;
  }
</style>
